<template>
  <div class="detail_Introduce">
    <!-- 详情报名框 -->
    <div class="detail_apply">
      <div class="detail_apply_img">
        <img :src="myitem.imgurl==null?'https://fview.5kjs.com/style/camp/banner/camp_img.jpg':myitem.imgurl" alt="" 
         @error="
            myitem.imgurl =
              'https://fview.5kjs.com/style/camp/banner/camp_img.jpg'
          " />
      </div>
      <div class="detail_apply_text">
        <!-- 左边文字部分 -->
        <div class="detail_apply_text_left">
          <div class="detail_apply_text_title">
            #
            {{ myitem.name }}
          </div>
          <div class="detail_apply_text_info">
            <div class="detail_apply_text_info_one">
              {{ myitem.users_count }}位学员 <span class="margin25">|</span>共{{
                myitem.days_num
              }}天
            </div>
            <div class="detail_apply_text_info_tow">
              开营周期：{{ myitem.begin_date }}~{{ myitem.end_date }}
            </div>
          </div>
        </div>
        <!-- 右边按钮部分 -->
        <div class="detail_apply_text_right">
          <div class="time" v-show="!myitem.is_apply">
            距离报名截止：
            <downTime :endTime="myitem.sign_end_date"></downTime>
          </div>
          <div
            class="detail_apply_btn"
            @click="apply()"
            v-if="!myitem.is_apply"
          >
            立即报名
          </div>
          <div class="detail_apply_btn" @click="apply()" v-if="myitem.is_apply">
            开始学习
          </div>
        </div>
      </div>
    </div>
    <!-- 详情页的排序框 -->
    <div class="detail_sorting_card">
      <div class="number">共计有{{ myshareItem.count }}条学员互动</div>
      <div class="sorting_box">
        排序：
        <span
          @click="changeActive(1)"
          :class="[activeNum == 1 ? 'sortActive' : '']"
          >按点赞量</span
        >
        <span class="shu">|</span>
        <span
          @click="changeActive(2)"
          :class="[activeNum == 2 ? 'sortActive' : '']"
          >按发表时间</span
        >
        <span class="shu">|</span>
        <span
          @click="changeActive(3)"
          :class="[activeNum == 3 ? 'sortActive' : '']"
          >按评论时间</span
        >
      </div>
    </div>
    <!-- 详情页的评论分享部分 -->
    <div class="Detail_content">
      <div class="left Detail_content_left">
        <div class="shard_btn_box">
          <div class="shard_btn" @click="myshare()">我要写日记</div>
          <myDiaLog
            ref="comment"
            :camp_id="mycamp_id"
            @addShar="AddShar($event)"
          ></myDiaLog>
        </div>
        <div class="shard_item" v-if="myshareItem.list != null">
          <shareCard
            v-for="(item, index) in myshareItem.list"
            :key="index"
            :myitem="item"
          ></shareCard>
          <MyPaginnation
            @one="onePage()"
            @next="nextPage()"
            :maxPage="totlePage"
            @Mychange="changePage($event)"
          ></MyPaginnation>
        </div>
        <!-- 空状态 -->
        <div v-else style="width: 100%">
          <div
            style="
              margin: auto;
              width: 18rem;
              height: 23rem;
              text-align: center;
              padding-bottom: 3rem;
            "
          >
            <img
              style="width: 90%; height: 90%"
              src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
              alt=""
            />
            <div style="color: #333333">暂时没有数据</div>
          </div>
        </div>
      </div>
      <div class="right Detail_content_right">
        <TopSearch :camp_id="mycamp_id"></TopSearch>
      </div>
    </div>
  </div>
</template>

<script>
import shareCard from "@/components/shareCard.vue";
import MyPaginnation from "@/components/MyPaginnation.vue";
import TopSearch from "@/components/topSearch.vue";
import downTime from "@/components/downTime.vue";
import myDiaLog from "@/components/myDiaLog.vue";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      // 当前排序方式
      activeNum: 2,
      // 当前路由编号（文章编号）
      mycamp_id: "",
      // 特训营详情信息
      myitem: [],
      // 当前类目下的分享列表
      myshareItem: [],
      // 当前页码
      nowPage: 1,
      // 每一页显示多少条数据
      limit: 7,
      // 当前最大页数
    };
  },
  components: { shareCard, MyPaginnation, TopSearch, downTime, myDiaLog },
  methods: {
    // 实时添加分享
    AddShar(event) {
      if (this.myshareItem.list != null) {
        this.myshareItem.list.unshift(event);
      } else {
        this.myshareItem.list = [];
        this.myshareItem.list.unshift(event);
      }
    },
    ...mapActions(["ifLogin"]),
    async apply() {
      var status = await this.ifLogin(this);
      if (status) {
        this.$router.push("/Detail/apply/" + this.mycamp_id);
      }
    },
    async myshare() {
      var status = await this.ifLogin(this);
      if (status) {
        this.$refs.comment.open();
      } else {
        setTimeout(() => {
          let nowUrl = window.location.href;
          nowUrl = nowUrl.replace(/#/g, "vue");
          let url = window.location.origin;
          window.location.href = url + "/login?turn_jump_url=" + nowUrl;
        }, 1000);
      }
    },
    changeActive(num) {
      this.activeNum = num;
      // 对分享内容进行排序
      this.getShareList(num);
    },
    // 请求特训营详情信息
    getCamp() {
      this.$axios
        .get("/getCamp", {
          params: {
            token: this.token,
            agency_id: 281,
            camp_id: this.mycamp_id,
          },
        })
        .then((doc) => {
          this.myitem = doc;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 请求当前camp_id下分享评论列表
    getShareList(mysort) {
      this.scrollTo();
      let sort = 2;
      if (mysort) {
        sort = mysort;
      }
      this.$axios
        .get("/getShareList", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
            sort: sort,
            limit: this.limit,
            page: this.nowPage,
          },
        })
        .then((doc) => {
          this.myshareItem = doc;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 根据排序重新请求数据
    // 返回第一页请求
    onePage() {
      if (this.nowPage == 1) {
        this.$message({
          message: "已经是第一页了噢~~~",
          type: "warning",
        });
        return;
      }
      this.nowPage = 1;
      this.getShareList(this.nowPage);
    },
    // 下一页
    nextPage() {
      if (this.nowPage == this.totlePage) {
        this.$message({
          message: "已经是最后一页啦~~~",
          type: "warning",
        });
        return;
      }
      // if()
      this.nowPage++;
      this.getShareList(this.nowPage);
    },
    // 页码跳转
    changePage(page) {
      this.nowPage = page;
      this.getShareList(this.nowPage);
    },
    // 滚动函数
    scrollTo() {
      setTimeout(() => {
        // event为需要跳转的锚点元素ID，如果event为0则返回顶部
        let y = 300;
        let duration = 500;
        /*y:目标纵坐标,duration:时间(毫秒)*/
        var scrollTop = document.documentElement.scrollTop;

        /*页面当前滚动距离*/
        var distance =
          y - scrollTop; /*结果大于0,说明目标在下方,小于0,说明目标在上方*/
        var scrollCount = duration / 10; /*10毫秒滚动一次,计算滚动次数*/
        var everyDistance =
          distance / scrollCount; /*滚动距离除以滚动次数计算每次滚动距离*/
        for (
          var index = 1;
          index <= scrollCount;
          index++ /*循环设置scrollBy事件,在duration之内,完成滚动效果*/
        )
          setTimeout(function () {
            window.scrollBy(0, everyDistance);
          }, 10 * index);
      }, 0);
    },
  },
  computed: {
    ...mapState(["agency_id", "token"]),
    // 分页总页数
    totlePage() {
      let totlePage = Math.ceil(this.myshareItem.count / this.limit);
      return totlePage;
    },
  },
  mounted() {
    this.mycamp_id = this.$route.params.id;
    this.getCamp();
    this.getShareList();
    if(this.$route.query.punch_clocks != null && this.$route.query.punch_clocks != undefined && this.$route.query.punch_clocks != '' ) {
      this.$refs.comment.open();
    }
  },
};
</script> 

<style lang="less" scoped>

/deep/ .pagination{
    .el-select{
      width: 100px;
    }
}

//   详情报名框
.detail_apply {
  padding: 1.3125rem 2.1875rem 1.3125rem;
  margin-bottom: 1.6875rem;
  display: flex;
  flex-direction: row;
  height: 10.3125rem;
  background: #ffffff;
  box-shadow: 0rem 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
  border-radius: 0.1875rem;
  // 图片部分
  .detail_apply_img {
    width: 10.8125rem;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  // 中间文字部分
  .detail_apply_text {
    flex: 1;
    margin-left: 2.1875rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    //   左边文字部分
    .detail_apply_text_left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .detail_apply_text_title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        margin-top: 0.5625rem;
        font-size: 1.375rem;
        font-family: " Microsoft YaHei";
        font-weight: 400;
        color: #535353;
      }
      .detail_apply_text_info {
        // margin-top: 2.5rem;
        .detail_apply_text_info_tow,
        .detail_apply_text_info_one {
          font-size: 0.875rem;
          font-family: " Microsoft YaHei";
          font-weight: 400;
          color: #9e9e9e;
          .margin25 {
            margin: 0 1.5625rem;
          }
        }
      }
      .detail_apply_text_info_tow {
        margin: 0.625rem 0;
      }
    }
    //   右边按钮部分
    .detail_apply_text_right {
      width: 18.5rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      .time {
        font-size: 0.875rem;
        font-family: " Microsoft YaHei";
        font-weight: 400;
        color: #6c6c6c;
        /deep/ .downTime {
          .time {
            margin-right: 0.3125rem;
            color: #ff583d;
            font-size: 0.875rem;
            font-weight: Bold;
          }
        }
      }
      .detail_apply_btn {
        margin-top: 1.5625rem;
        width: 15.625rem;
        height: 2.8125rem;
        background: #ff583d;
        border-radius: 1.4375rem;
        font-size: 1.125rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 2.8125rem;
        cursor: pointer;
      }
    }
  }
}
//   详情页的排序框
.detail_sorting_card {
  margin-bottom: 1.25rem;
  padding: 0 1.3125rem 0 2.5625rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3.8125rem;
  background: #ffffff;
  border: 0.0625rem solid #f0f1f1;
  .number {
    font-size: 0.875rem;
    font-family: " Microsoft YaHei";
    font-weight: 400;
    color: #a09ea6;
  }
  .sorting_box {
    cursor: pointer;
    font-size: 0.875rem;
    font-family: " Microsoft YaHei";
    font-weight: 400;
    color: #b2b1b1;
  }
  // 当前活动的排序
  .sortActive {
    color: #ff7862;
  }
  // 竖条
  .shu {
    margin: 0 0.8125rem;
  }
}
//   详情页的评论分享部分
.Detail_content {
  width: 100%;
  overflow: hidden;
  .Detail_content_left {
    width: 56.9375rem;
    height: auto;
    background: #ffffff;
    box-shadow: 0rem 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
    .shard_btn_box {
      padding: 1.5625rem 2.4375rem;
      border-bottom: 0.0625rem solid#F0F1F1;
      .shard_btn {
        width: 52.0625rem;
        height: 3.375rem;
        background: #ff7862;
        border-radius: 0.125rem;
        font-size: 1rem;
        font-family: "Microsoft YaHei";
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        line-height: 3.375rem;
        cursor: pointer;
      }
    }
    //   评论组件部分
    /deep/ .shard_item {
      // background-color: #f9f9f9;
      .sharCard {
        width: 100%;
        border: none;
        border-bottom: 0.0625rem solid#F0F1F1;
        background-color: #ffffff;
        .comment_content {
          width: 100%;
        }
        .edit_comment {
          width: 100%;
          .edit_input_box {
            width: 100%;
          }
          .pinglunBox {
            width: 44.125rem;
          }
        }
      }
    }
  }
  .Detail_content_right {
    width: 18.75rem;
    height: auto;
    background: #ffffff;
    border: 1px solid #eeeeee;
  }
}
</style>